import { Event } from "./Event";
/**
 * Property Changed Event
 */
export class PropertyChangedEvent extends Event {
    /**
     * Constructor
     * @param element element
     * @param data data
     * @param property property
     * @param value value
     * @param index index (optional)
     */
    constructor(element, data, property, value, index) {
        super(element, data);
        this.property = property;
        this.value = value;
        this.index = index;
    }
    /**
     * Gets property name
     */
    getProperty() {
        return this.property;
    }
    /**
     * Gets property value
     */
    getValue() {
        return this.value;
    }
    /**
     * Gets index in array if object is in array
     */
    getIndex() {
        return this.index;
    }
}
//# sourceMappingURL=PropertyChangedEvent.js.map